var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { TubeType, NodeComponentType, } from "store/types";
import { Unit } from "utility/number";
import { tubeConnectionModels } from "3d/constants/common";
import { piGripAddonPlaceholder } from "api/tacton/constants";
export var TableCellType;
(function (TableCellType) {
    TableCellType["STRING"] = "string";
    TableCellType["NUMBER"] = "number";
    TableCellType["TRANSLATION_KEY"] = "translation-key";
    TableCellType["LINK"] = "link";
})(TableCellType || (TableCellType = {}));
function buildSelectionTableRows(selections, components, options) {
    var groupedSelections = Object.entries(selections).reduce(function (grouped, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], current = _c[1];
        if (!current) {
            return grouped;
        }
        var component = components[current];
        var override = (_b = options === null || options === void 0 ? void 0 : options.transform) === null || _b === void 0 ? void 0 : _b.call(options, component, key, current);
        var selection = __assign({ name: component.label, quantity: 1, prelCode: component.articleNumber, link: component.link }, override);
        var groupKey = current + selection.prelCode + selection.name;
        if (grouped[groupKey]) {
            grouped[groupKey].quantity += 1;
        }
        else {
            grouped[groupKey] = selection;
        }
        return grouped;
    }, {});
    return Object.values(groupedSelections).map(function (group) { return [
        { value: group.name, type: TableCellType.STRING },
        { value: group.quantity, type: TableCellType.NUMBER },
        { value: group.prelCode, type: TableCellType.STRING },
        { value: group.link, type: TableCellType.LINK },
    ]; });
}
export var getSelectionTableRows = function (selections, components) {
    return buildSelectionTableRows(selections, components);
};
export var getCupTechnologySelectionTableRows = function (selectionMap, selections, components, suctionCups, formatIncludedIn) {
    return buildSelectionTableRows(selections, components, {
        transform: function (component, key) {
            var _a;
            var gripPositionKey = (_a = Object.entries(selectionMap).find(function (_a) {
                var _b = __read(_a, 2), _ = _b[0], value = _b[1];
                return value === key;
            })) === null || _a === void 0 ? void 0 : _a[0];
            if (!gripPositionKey)
                return {};
            var cupSelectionField = suctionCups.selectionMap[gripPositionKey];
            var selectionValue = suctionCups.selections[cupSelectionField];
            var cupOnSameGripPosition = selectionValue && suctionCups.components[selectionValue];
            if (cupOnSameGripPosition &&
                cupOnSameGripPosition.articleNumber.includes(piGripAddonPlaceholder)) {
                return {
                    name: "".concat(component.label, " ").concat(formatIncludedIn(cupOnSameGripPosition.label)),
                };
            }
            return {};
        },
    });
};
export var getCupSelectionTableRows = function (selectionMap, selections, components, cupTechnologies) {
    return buildSelectionTableRows(selections, components, {
        // if the cup has a tech-code placeholder, it means that a cup technology might be considered a part of that cup, and this should be indicated by replacing the placeholder with the pigripCode of the cup technology
        transform: function (component, key) {
            var _a;
            var gripPositionKey = (_a = Object.entries(selectionMap).find(function (_a) {
                var _b = __read(_a, 2), _ = _b[0], value = _b[1];
                return value === key;
            })) === null || _a === void 0 ? void 0 : _a[0];
            if (!gripPositionKey) {
                return {};
            }
            var cupTechnologySelectionField = cupTechnologies.selectionMap[gripPositionKey];
            var cupTechnologyValue = cupTechnologies.selections[cupTechnologySelectionField];
            var cupTechnologyComponentOnSameGripPosition = cupTechnologyValue
                ? cupTechnologies.components[cupTechnologyValue]
                : null;
            return {
                prelCode: component.articleNumber.replace(piGripAddonPlaceholder, (cupTechnologyComponentOnSameGripPosition === null || cupTechnologyComponentOnSameGripPosition === void 0 ? void 0 : cupTechnologyComponentOnSameGripPosition.pigripCode) || "00"),
            };
        },
    });
};
export var getTubeConnectionTableRows = function (nodes, convertNumber) {
    var tubeConnectionGroups = {};
    Object.values(nodes).forEach(function (node) {
        if (node.type === NodeComponentType.TUBE_CONNECTION) {
            var component = node.component;
            // A placeholder is not a part of the system yet.
            if (component.type === undefined)
                return;
            var convertedDiameters_1 = [];
            component.diameters.map(function (diameter) {
                convertedDiameters_1.push(convertNumber(diameter, Unit.M).formatted);
            });
            var componentKey = "".concat(component.type, "-").concat(component.diameters);
            if (tubeConnectionGroups[componentKey]) {
                tubeConnectionGroups[componentKey].quantity += 1;
            }
            else {
                tubeConnectionGroups[componentKey] = {
                    name: tubeConnectionModels[component.type].translationKey,
                    diameters: convertedDiameters_1,
                    quantity: 1,
                };
            }
        }
    });
    return Object.values(tubeConnectionGroups).map(function (group) {
        return [
            { value: group.name, type: TableCellType.TRANSLATION_KEY },
            { value: group.quantity, type: TableCellType.NUMBER },
            { value: group.diameters.join(", "), type: TableCellType.STRING },
        ];
    });
};
export var getTubeTableRows = function (edges, useDoubleCompressedAirTubes, convertNumber) {
    var edgeGroups = Object.values(edges).reduce(function (groups, currentEdge) {
        var addTubeToGroups = function (key, translationId, diameter) {
            if (groups[key]) {
                groups[key].quantity++;
            }
            else {
                groups[key] = {
                    translationId: translationId,
                    length: convertNumber(currentEdge.length, Unit.M).formatted,
                    diameter: convertNumber(diameter, Unit.M).formatted,
                    quantity: 1,
                };
            }
        };
        if (currentEdge.tubeType === TubeType.COMPRESSED_AIR &&
            useDoubleCompressedAirTubes) {
            addTubeToGroups("".concat(currentEdge.length, "-").concat(currentEdge.diameterDefaultTube, "-compressed-air"), "summary_modal.table.tube_types.".concat(TubeType.COMPRESSED_AIR), currentEdge.diameterDefaultTube);
            addTubeToGroups("".concat(currentEdge.length, "-").concat(currentEdge.diameterBlowOffTube, "-compressed-air-bo"), "summary_modal.table.tube_types.".concat(TubeType.COMPRESSED_AIR, "_blow_off"), currentEdge.diameterBlowOffTube);
        }
        else {
            addTubeToGroups("".concat(currentEdge.length, "-").concat(currentEdge.diameterDefaultTube, "-").concat(currentEdge.tubeType), "summary_modal.table.tube_types.".concat(currentEdge.tubeType), currentEdge.diameterDefaultTube);
        }
        return groups;
    }, {});
    return Object.values(edgeGroups).map(function (group) { return [
        { value: group.translationId, type: TableCellType.TRANSLATION_KEY },
        { value: group.quantity, type: TableCellType.NUMBER },
        { value: group.length, type: TableCellType.STRING },
        { value: group.diameter, type: TableCellType.STRING },
    ]; });
};
